import Vue from 'vue';
import App from './views/app';
import router from './router';
import store from './store';
import i18n from './i18n';
import { Settings } from 'luxon';

Vue.config.productionTip = false;
Vue.prototype.$Store = store;
Vue.prototype.$package = require('@/../package.json');
Settings.defaultLocale = 'nl';

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
